import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { Routes, Route, HashRouter, BrowserRouter } from 'react-router-dom';
import './index.css';
import Dashboard from './components/structure/Dashboard';
import SignupLogin from './components/structure/Signup/SignupLogin';



ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <BrowserRouter basename={"/sortyourkip"}>
                <div className="App">
                    <Routes>
                        <Route exact path="/" element={<Dashboard />} />
                        <Route exact path="/dashboard" element={<Dashboard />} />
                        <Route path="/signup" element={<SignupLogin />} />
                        <Route path="/login" element={<SignupLogin />} />
                        <Route path="/signmeup" element={<SignupLogin />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);